import React, { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import IconVisibility from "../componentsStyled/icon/iconvisibility";
import IconVisibilityOff from "../componentsStyled/icon/iconvisibilityoff";
import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from "@mui/material";
import apiConnect from "../api/apiConnect";
import LoadingBox from "./LoadingBox";

interface User {
  email: string;
  password: string;
}

const Validation: React.FC<any> = ({ pageDestiny }) => {
  const [user, setUser] = useState<User>({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);
    apiConnect.apiAPP
      .post("/login", user)
      .then((response) => {
        const username = response.data.email;
        const password = response.data.token;
        const text: string = username + ":" + password;
        const encoder: TextEncoder = new TextEncoder();
        const data: Uint8Array = encoder.encode(text);
        const dataArray: number[] = Array.from(data);
        const binaryString: string = String.fromCharCode.apply(null, dataArray);
        const basicAuth: string = btoa(binaryString);

        const authData = {
          basicAuth: basicAuth,
          code: response.data.code,
          email: response.data.email,
          customerId: response.data.customerId,
          token: response.data.token,
          name: response.data.name,
        };
        localStorage.setItem("auth", JSON.stringify(authData));
        navigate(`/${pageDestiny}`);
      })
      .catch((error) => {
        console.error("Erro fazer login:", error);
        setError("Ocorreu um erro, por favor, verifique seus dados e tente novamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    setError(null);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <TextField variant="outlined" placeholder="Insira seu e-mail ou CPF" onChange={handleChange} name="email" InputProps={{ sx: { borderRadius: 3 } }} />
          <FormControl variant="outlined">
            <OutlinedInput
              type={showPassword ? "text" : "password"}
              placeholder="Insira sua senha"
              sx={{ borderRadius: 3, bgcolor: "#fff" }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <IconVisibilityOff width={24} /> : <IconVisibility width={24} />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={handleChange}
              name="password"
            />
          </FormControl>
        </Box>

        {error && (
          <Box mt={2}>
            <span style={{ color: "red" }}>*{error}</span>
          </Box>
        )}

        <a className="resetpasswordLogin" href="https://www.kappa.com.br/loja/recuperar_senha.php">
          Esqueci a senha
        </a>
      </Box>

      {loading && <LoadingBox loadType="static" />}

      <Box width={{ xs: 300, md: 300 }} margin={"0 auto"}>
        <Button type="submit" variant="contained" style={{ borderRadius: 100, width: "100%", backgroundColor: "#000", marginTop: 20 }}>
          Entrar
        </Button>
      </Box>
    </form>
  );
};

export default Validation;
